export default __webpack_public_path__ + "c090d4ff601c67d47301923eb6243517.png";